module.exports = __webpack_public_path__ + "static/media/maciej-kowalski.11cce661.jpg";